import type {
  AdvancedScorecard_Scorecard as Scorecard,
  AdvancedScorecard_GetScorecardsResponse as GetScorecardsResponse,
  AdvancedScorecard_GetScorecardCategoriesResponse as GetScorecardCategoriesResponse,
  AdvancedScorecard_CreateCategoryRequest as CreateCategoryRequest,
  AdvancedScorecard_CategoryItem as CategoryItem,
  AdvancedScorecard_UpdateCategoryRequest as UpdateCategoryRequest,
  AdvancedScorecard_GetCategoryRequest as GetCategoryRequest,
  AdvancedScorecard_AccountCategory as AccountCategory,
  AdvancedScorecard_CreateScorecardRequest as CreateScorecardRequest,
  AdvancedScorecard_GetScorecardRequest as GetScorecardRequest,
  AdvancedScorecard_UpdateScorecardStatusRequest as UpdateScorecardStatusRequest,
  AdvancedScorecard_GetRootCausesResponse as GetRootCausesResponse,
  AdvancedScorecard_CreateRootCauseRequest as CreateRootCauseRequest,
  AdvancedScorecard_UpdateRootCauseRequest as UpdateRootCauseRequest,
  AdvancedScorecard_RootCause as RootCause,
  AdvancedScorecard_UpdateScorecardRequest as UpdateScorecardRequest,
  AdvancedScorecard_RootCauseRequest as DeleteRootCauseRequiest,
  AdvancedScorecard_GetCustomPromptCategoryLibraryResponse as GetCustomPromptCategoriesResponse,
  AdvancedScorecard_UpdateCategoryStatusRequest as UpdateCategoryStatusRequest,
  AdvancedScorecard_DeleteCategoryRequest as DeleteCategoryRequest,
  AdvancedScorecard_DeleteScorecardRequest as DeleteScorecardRequest,
  AdvancedScorecard_GetScorecardsRequest as GetScorecardsRequest,
  AdvancedScorecard_GetCategoriesRequest as GetCategoriesRequest,
  AdvancedScorecard_GetRootCausesRequest as GetRootCausesRequest,
  DynamicScorecardOptionsResponse,
} from '@zendesk/zqa-services/scorecards'
import qs from 'query-string'

import { api } from '@/api'

export const getScorecards = (searchParams?: GetScorecardsRequest): Promise<GetScorecardsResponse> =>
  api.get('settings/reviews/scorecards', { searchParams: qs.stringify(searchParams) }).json()

export const getCategories = (searchParams?: GetCategoriesRequest): Promise<GetScorecardCategoriesResponse> =>
  api.get('settings/reviews/categories', { searchParams: qs.stringify(searchParams) }).json()

export const addCategory = (json: CreateCategoryRequest): Promise<CategoryItem> => {
  return api.post('settings/reviews/categories', { json }).json()
}

export const editCategory = (json: UpdateCategoryRequest): Promise<CategoryItem> => {
  return api.put(`settings/reviews/categories/${json.id}`, { json }).json()
}

export const getCategory = (id: GetCategoryRequest['categoryId']): Promise<AccountCategory> => {
  return api.get(`settings/reviews/categories/${id}`).json()
}

export const deleteCategory = (id: DeleteCategoryRequest['categoryId']): Promise<void> => {
  return api.delete(`settings/reviews/categories/${id}`).json()
}

export const updateCategoryStatus = (req: UpdateCategoryStatusRequest): Promise<void> => {
  return api.put(`settings/reviews/categories/${req.id}/status`, { json: { status: req.status } }).json()
}

export const createScorecard = (scorecard: CreateScorecardRequest): Promise<Scorecard> => {
  return api.post('settings/reviews/scorecards', { json: scorecard }).json()
}

export const updateScorecard = (
  id: UpdateScorecardRequest['scorecardId'],
  scorecard: Omit<UpdateScorecardRequest, 'scorecardId'>,
): Promise<Scorecard> => {
  return api.put(`settings/reviews/scorecards/${id}`, { json: scorecard }).json()
}

export const updateScorecardStatus = (req: UpdateScorecardStatusRequest): Promise<void> => {
  return api.put(`settings/reviews/scorecards/${req.scorecardId}/status`, { json: { status: req.status } }).json()
}

export const getRootCauses = (searchParams?: GetRootCausesRequest): Promise<GetRootCausesResponse> =>
  api.get('settings/reviews/root-causes', { searchParams: qs.stringify(searchParams) }).json()

export const createRootCause = (json: CreateRootCauseRequest): Promise<RootCause> => {
  return api.post('settings/reviews/root-causes', { json }).json()
}

export const updateRootCause = (json: UpdateRootCauseRequest): Promise<RootCause> => {
  return api.put(`settings/reviews/root-causes/${json.rootCauseId}`, { json }).json()
}

export const deleteRootCause = (json: DeleteRootCauseRequiest): Promise<void> => {
  return api.delete(`settings/reviews/root-causes/${json.rootCauseId}`).json()
}

export const getScorecard = (request: GetScorecardRequest): Promise<Scorecard> => {
  return api.get(`settings/reviews/scorecards/${request.scorecardId}`).json()
}

export const deleteScorecard = (request: DeleteScorecardRequest): Promise<void> => {
  return api.delete(`settings/reviews/scorecards/${request.scorecardId}`).json()
}

export const getCustomCategoryPrompts = (): Promise<GetCustomPromptCategoriesResponse> =>
  api.get('settings/reviews/custom-prompt-categories/library').json()

export const getCategoryConditions = (): Promise<DynamicScorecardOptionsResponse> => {
  return api.get('settings/reviews/dynamic-scorecard-options').json()
}
